import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-22eeef6c")
const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "高級檢索", -1)
const _hoisted_2 = { class: "footer" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 重置 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("搜索 ")
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_BaseForm = _resolveComponent("BaseForm")!

  return (_openBlock(), _createBlock(_component_BaseForm, _mergeProps(_ctx.formConfig, {
    modelValue: _ctx.formData,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.formData = $event)),
    class: "page-search"
  }), {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_button, {
          icon: "el-icon-search",
          onClick: _ctx.handleResetClick
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, {
          type: "primary",
          icon: "el-icon-refresh",
          onClick: _ctx.handleSearchClick
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _: 1
  }, 16, ["modelValue"]))
}